import u from "./ui.module.css";

function initials(name) {
  const parts = String(name || "?")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return (parts[0]?.[0] || "?").toUpperCase();
}

export default function Avatar({ name, src, size = "md", className = "" }) {
  const sizeClass =
    size === "lg" ? u.avatarLg : size === "sm" ? u.avatarSm : u.avatarMd;
  return (
    <div
      className={`${u.avatar} ${sizeClass} ${src ? u.avatarWithPhoto : ""} ${className}`}
      aria-hidden
    >
      {src ? (
        <img src={src} alt="" className={u.avatarImg} />
      ) : (
        initials(name)
      )}
    </div>
  );
}
